"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagedDecimalSignedValue = exports.ManagedDecimalSignedType = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const types_1 = require("./types");
class ManagedDecimalSignedType extends types_1.Type {
    constructor(metadata) {
        super("ManagedDecimalSigned", undefined, undefined, metadata);
    }
    getClassName() {
        return ManagedDecimalSignedType.ClassName;
    }
    getMetadata() {
        return this.metadata;
    }
    isVariable() {
        return this.metadata == "usize";
    }
}
exports.ManagedDecimalSignedType = ManagedDecimalSignedType;
ManagedDecimalSignedType.ClassName = "ManagedDecimalSignedType";
class ManagedDecimalSignedValue extends types_1.TypedValue {
    constructor(value, scale, isVariable = false) {
        super(new ManagedDecimalSignedType(isVariable ? "usize" : scale));
        this.value = new bignumber_js_1.default(value);
        this.scale = scale;
        this.variable = isVariable;
    }
    getClassName() {
        return ManagedDecimalSignedValue.ClassName;
    }
    getPrecision() {
        return this.value.toFixed(this.scale).replace(".", "").length;
    }
    getScale() {
        return this.scale;
    }
    /**
     * Returns whether two objects have the same value.
     */
    equals(other) {
        if (this.getPrecision() != other.getPrecision()) {
            return false;
        }
        return new bignumber_js_1.default(this.value).eq(other.value);
    }
    valueOf() {
        return this.value;
    }
    toString() {
        return this.value.toFixed(this.scale);
    }
    isVariable() {
        return this.variable;
    }
}
exports.ManagedDecimalSignedValue = ManagedDecimalSignedValue;
ManagedDecimalSignedValue.ClassName = "ManagedDecimalSignedValue";
//# sourceMappingURL=managedDecimalSigned.js.map